export default {
    apiKey: "AIzaSyDddkRkVXKmpoO6pCohVsXMwb7A2YmgFA8",
    authDomain: "free-books-eb916.firebaseapp.com",
    databaseURL: "https://free-books-eb916.firebaseio.com",
    projectId: "free-books-eb916",
    storageBucket: "free-books-eb916.appspot.com",
    messagingSenderId: "753709363182"
};